import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { IsEmail } from 'class-validator';
import { action, makeAutoObservable, observable } from 'mobx';

import { RequestChangePasswordCollaboration } from '@/modules/recognition/application/collaborations/request-change-password.collaboration';
import { ObservableForm } from '@/shared/presentation/forms/BaseForm';

class ForgotPassForm {
  @IsEmail({}, { message: 'E-mail inválido' })
  email = '';
}

interface ForgotPassDto {
  email: string;
}

@ViewModel()
export class ForgotPassViewModel implements IReactiveModel {
  @observable form = new ObservableForm(ForgotPassForm);
  @observable isSubmitting = false;
  @observable errorMessage = '';
  @observable disabledButotn = '';
  @observable emailSent = false;

  constructor(private requestChangePasswordCollaboration: RequestChangePasswordCollaboration) {
    makeAutoObservable(this);
  }

  async onInit() {}

  @action
  async forgotPass() {
    try {
      if (this.form.hasError) {
        return;
      }

      this.isSubmitting = true;
      this.errorMessage = '';

      const dto: ForgotPassDto = {
        email: this.form.values.email,
      };

      await this.requestChangePasswordCollaboration.run(dto);
      this.emailSent = true;
    } catch (error) {
      console.error(error);
      this.errorMessage = 'Ocorreu um erro ao tentar enviar email de recuperação de senha.';
    } finally {
      this.isSubmitting = false;
    }
  }
}
